import React from 'react';
import {Counter, cn} from '@chekinapp/ui';
import {COUNTER_ROW_CLASS} from './constants';

type ConfirmCounterProps = {
  title?: string;
  subtitle?: string | React.ReactNode;
  icon?: React.ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  value: number;
  onChange: (value: number) => void;
  error?: string;
  maxNumber?: number;
};

const CounterStepper = React.forwardRef<HTMLDivElement, ConfirmCounterProps>(
  (
    {title, subtitle, icon, value, onChange, error, disabled, readOnly, maxNumber},
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'counter-stepper flex w-full items-center gap-3.5',
          COUNTER_ROW_CLASS,
          readOnly && 'border-transparent bg-transparent px-0 py-2',
        )}
      >
        {icon && (
          <span className="counter-stepper__icon grid size-8 shrink-0 place-items-center rounded-[10px] bg-[var(--chekin-color-surface-pressed)] text-[var(--chekin-color-brand-blue)]">
            {icon}
          </span>
        )}
        <div className="counter-stepper__details min-w-0 flex-1">
          {Boolean(title) && (
            <div
              className={cn(
                'counter-stepper__title text-[15px] font-medium leading-tight text-[var(--chekin-color-brand-navy)]',
              )}
            >
              {title}
            </div>
          )}
          {Boolean(subtitle) && (
            <div className="counter-stepper__subtitle mt-0.5 text-[13px] leading-snug text-[var(--chekin-text-secondary)]">
              {subtitle}
            </div>
          )}
        </div>
        {readOnly ? (
          <span className="counter-stepper__value grid h-9 min-w-[42px] place-items-center rounded-[12px] bg-[var(--chekin-blue-tint-info)] px-2.5 text-[18px] font-bold tabular-nums text-[var(--chekin-color-brand-navy)]">
            {value}
          </span>
        ) : (
          <Counter
            value={value}
            onChange={onChange}
            disabled={disabled}
            error={error}
            maxNumber={maxNumber}
            className="!w-auto gap-[18px]"
          />
        )}
      </div>
    );
  },
);

export {CounterStepper};
